import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
}

/**
 * Catches render-time crashes so a single broken page doesn't blank the
 * whole app. Route-level errors from lazy() imports land here too.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled render error", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="page">
        <div className="container container--narrow stack">
          <h1>Something broke</h1>
          <p className="muted">
            An unexpected error stopped this page from rendering. Reloading usually clears it.
          </p>
          <pre
            className="card"
            style={{
              padding: "var(--s-4)",
              overflowX: "auto",
              fontSize: "var(--text-xs)",
              color: "var(--fg-muted)",
            }}
          >
            {this.state.error.message}
          </pre>
          <div className="row">
            <button className="btn btn--primary" onClick={() => window.location.reload()}>
              Reload
            </button>
            <a className="btn btn--secondary" href="/">
              Go home
            </a>
          </div>
        </div>
      </main>
    );
  }
}
